var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 4.25V10.3438C11.7188 10.4681 11.6694 10.5873 11.5815 10.6752C11.4936 10.7631 11.3743 10.8125 11.25 10.8125C11.1257 10.8125 11.0065 10.7631 10.9186 10.6752C10.8307 10.5873 10.7813 10.4681 10.7813 10.3438V5.38145L4.08166 12.0816C3.9937 12.1696 3.87441 12.219 3.75002 12.219C3.62563 12.219 3.50633 12.1696 3.41838 12.0816C3.33042 11.9937 3.28101 11.8744 3.28101 11.75C3.28101 11.6256 3.33042 11.5063 3.41838 11.4184L10.1186 4.71875H5.15627C5.03195 4.71875 4.91272 4.66936 4.82481 4.58146C4.7369 4.49355 4.68752 4.37432 4.68752 4.25C4.68752 4.12568 4.7369 4.00645 4.82481 3.91854C4.91272 3.83064 5.03195 3.78125 5.15627 3.78125H11.25C11.3743 3.78125 11.4936 3.83064 11.5815 3.91854C11.6694 4.00645 11.7188 4.12568 11.7188 4.25Z",
    fill: "#232D35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/ArrowUpRight.f937f90b.svg";
export { ForwardRef as ReactComponent };